<template>
  <div class="terms">
    <p class="terms-title">
      House730放盤條款與條件
    </p>
    <ul class="terms-line">
      <li
        v-for="item in terms"
        :key="item.id"
      >
        {{ item.data }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
    data() {
        return {
            terms: [
                {
                    id: 1,
                    data: '1.當House730會員於House730網站 (www.house730.com) 及應用程式 (下稱「House730」) 放盤時，請詳細閱讀以下條款與條件，勾選「同意放盤條款」即表示同意並接受以下全部條款與條件，不得異議。'
                },
                {
                    id: 2,
                    data: '2.除符合相關法例外，House730會員不可刊登發展商之一手住宅樓盤，若發現有違規情況，該樓盤會立即被封鎖，相關House730金幣/鑽石會被沒收而不予退回，亦不會發出通知給相關會員。'
                },
                {
                    id: 3,
                    data: '3.放盤有效期內屋苑名稱不能修改。放盤有效期過後，樓盤的所有內容都不能修改。'
                },
                {
                    id: 4,
                    data: '4.House730會員的聯絡方法，只能填寫於本網站「聯絡電話」一欄內。若聯絡資料輸入至其他欄位，House730有權刪除該聯絡資料而不會發出通知給該會員。'
                },
                {
                    id: 5,
                    data: '5.House730分配的每個樓盤編號，只能刊登一個物業資料，若刊登內容明顯多於一個物業，House730會立即封鎖該樓盤，相關House730金幣/鑽石會被沒收而不予退回，亦不會發出通知給相關會員。'
                },
                {
                    id: 6,
                    data: '6.地產代理於House730刊登的樓盤，同樣受地產代理監管局的《地產代理條例》所約束。如有任何違例事項，House730會將資料交予地產代理監管局跟進。'
                },
                {
                    id: 7,
                    data: '7.地產代理刊登的樓盤只能以地產代理身份刊登，不能冒充業主身份刊登，一經發現違規，House730會立即刪除以該會員帳號刊登之所有樓盤、封鎖樓盤刊登及留言權限，相關House730金幣/鑽石會被沒收而不予退回，亦不會發出通知給該會員。'
                },
                {
                    id: 8,
                    data: '8.若有任何盤源之爭拗，House730有權要求放盤會員提供該樓盤的委託放盤證明、確實地址、業權證明及其他相關資料等，予House730核實。若放盤會員未能提供所需資料，House730將有權停止刊登該樓盤，直至收到所需資料及完成核實。'
                },
                {
                    id: 9,
                    data: '9.House730有權抽查懷疑有問題的樓盤，被抽查樓盤之放盤會員，必須提供該樓盤的的委託放盤證明、確實地址、業權證明及其他相關資料等，予House730核實。若放盤會員未能提供所需資料，House730將有權停止刊登該樓盤，直至收到所需資料及完成核實。'
                },
                {
                    id: 10,
                    // data: '10.House730刊登的樓盤，包括樓盤資料及相片，除由會員提供外版權均屬House730所有，屬House730 的財產。若刊登樓盤之會員要求刪除已刊登之樓盤，須向House730支付行政費用港幣500元。'
                    data:'10.於House730刊登的樓盤， House730有權使用作任何推廣用途 。 House730刊登的樓盤，包括但不限於樓盤資料、相片、影片及VR，除由會員提供外版權均屬House730所有，屬House730 的財產。若刊登樓盤之會員要求刪除已刊登之樓盤，須向House730支付行政費用港幣500元。'
                },
                {
                    id: 11,
                    data: '11.House730非常重視代理盤冒充業主盤之問題，若收到投訴，Hosue730會作出調查，若認為情況屬實，刊登該樓盤之會員的所有樓盤會即時被封鎖，直至該會員提供相關資料證明才會解封。'
                },
                {
                    id: 12,
                    data: '12.會員不可透過放盤，刊登任何徵求樓盤之廣告或涉及商業活動的訊息，若House730發現違規，House730有權封鎖該樓盤，而House730金幣/鑽石不予退回。'
                },
                {
                    id: 13,
                    data: '13.以上條款與條件不時會有修訂，House730恕不另行通知。'
                }
            ]
        };
    }
};
</script>
<style lang="less" scoped>
.terms {
    text-align: left;
    font-family: PingFangSC-Regular;
    .terms-title {
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(23, 23, 37, 1);
        line-height: 33px;
        margin-bottom: 22px;
    }
    .terms-line {
        font-size: 20px;
        font-weight: 400;
        color: rgba(68, 68, 79, 1);
        line-height: 44px;
    }
    ul {
        margin: 0;
        padding: 0;
        list-style: none;
        li {
            margin-bottom: 10px;
        }
    }
    p {
        margin: 0;
        padding: 0;
    }
}
</style>
